import type { LucideIcon } from 'lucide-react';

type IconProps = {
  icon: LucideIcon;
  size?: number;
  /** Accessible name. Without it the icon is decorative (aria-hidden). */
  label?: string;
  className?: string;
  color?: string;
};

/** Lucide icon that inherits currentColor, 2px rounded stroke (design-system Icon). */
export function Icon({ icon: Glyph, size = 20, label, className, color }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={2}
      color={color ?? 'currentColor'}
      className={className}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
      style={{ flex: 'none' }}
    />
  );
}
